export const WIX_VIBE_DOMAINS_ARTICLE_ID = 'd5ba195d-dd89-4901-92bb-9a7bbf5f0dac';
export const RECONNECT_VIA_NAMESERVERS_ARTICLE_ID = '4b8acfe1-0767-4d99-b201-bd7c313d2065';
//# sourceMappingURL=supportArticleIds.js.map